import { type Transition, type Variants } from 'framer-motion';

export enum CharacterLimitVariant {
    Initial = 'initial',
    Show = 'show',
}

export const characterLimitVariants: Variants = {
    [CharacterLimitVariant.Initial]: {
        opacity: 0,
        // TODO: Should use a `$yat-spacing` token
        translateY: 10,
    },
    [CharacterLimitVariant.Show]: {
        opacity: 1,
        translateY: 0,
    },
};
export const characterLimitTransition: Transition = {
    type: 'spring',
    bounce: 0.4,
    duration: 0.28,
};
